import { render, staticRenderFns } from "./dashboard-edit-menu.vue?vue&type=template&id=e1c098c4"
import script from "./dashboard-edit-menu.vue?vue&type=script&lang=js"
export * from "./dashboard-edit-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports